import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getShiftStatusRequest: null,
  getShiftStatusSuccess: ['response'],
  getShiftStatusFailure: null,

  changeShiftCheckListStatus: ['status'],

  startShiftRequest: ['shiftType', 'shiftId', 'payload'],
  startShiftSuccess: ['response'],
  startShiftFailure: null,

  pauseShiftRequest: ['shiftTimeId', 'payload'],
  pauseShiftSuccess: ['pauseTimeId', 'pauseTimeStart'],
  pauseShiftFailure: null,

  resumeShiftRequest: ['shiftTimeId', 'payload'],
  resumeShiftSuccess: ['totalPauseTimes'],
  resumeShiftFailure: null,

  takeBreakRequest: ['shiftTimeId', 'startedBreak', 'payload'],
  takeBreakSuccess: ['breakTimeId', 'startedBreak'],
  takeBreakFailure: ['startedBreak'],

  endBreakRequest: ['shiftTimeId', 'breakTimeId', 'breakId', 'payload'],
  endBreakSuccess: ['breakId'],
  endBreakFailure: null,

  endShiftRequest: ['shiftTimeId', 'payload'],
  endShiftSuccess: ['response'],
  endShiftFailure: null,

  trackLocationRequest: ['shiftTimeId', 'payload'],
  trackLocationSuccess: ['response'],
  trackLocationFailure: null,

  getShiftRepossessionsOverviewRequest: ['shiftTimeId'],
  getShiftRepossessionsOverviewSuccess: ['response'],
  getShiftRepossessionsOverviewFailure: null,

  getShiftRepossessionsGoalsRequest: ['shiftId'],
  getShiftRepossessionsGoalsSuccess: ['response'],
  getShiftRepossessionsGoalsFailure: null,

  getShiftRepossessionsHitListRequest: ['branchId'],
  getShiftRepossessionsHitListSuccess: ['response'],
  getShiftRepossessionsHitListFailure: null,

  getSpottedVehicleByVinRequest: ['shiftTimeId', 'vin'],
  getSpottedVehicleByVinSuccess: ['response'],
  getSpottedVehicleByVinFailure: null,

  submitSpottedVehicleRequest: ['shiftTimeId', 'payload'],
  submitSpottedVehicleSuccess: null,
  submitSpottedVehicleFailure: null,

  getCustomCommissionsRequest: null,
  getCustomCommissionsSuccess: ['response'],
  getCustomCommissionsFailure: null,

  submitCustomCommissionRequest: ['payload'],
  submitCustomCommissionSuccess: ['response'],
  submitCustomCommissionFailure: null,

  updateCustomCommissionRequest: ['commissionId', 'payload'],
  updateCustomCommissionSuccess: ['response'],
  updateCustomCommissionFailure: ['commissionId'],

  cancelCustomCommissionRequest: ['commissionId'],
  cancelCustomCommissionSuccess: ['commissionId'],
  cancelCustomCommissionFailure: ['commissionId'],

  getShiftInfractionsRequest: ['shiftTimeId'],
  getShiftInfractionsSuccess: ['response'],
  getShiftInfractionsFailure: null,

  getShiftPendingInfractionsRequest: ['shiftTimeId'],
  getShiftPendingInfractionsSuccess: ['response'],
  getShiftPendingInfractionsFailure: null,

  submitInfractionAnswerRequest: ['breakId', 'payload'],
  submitInfractionAnswerSuccess: ['response'],
  submitInfractionAnswerFailure: null,

  clearSuccessStartShiftRequest: null,
  clearBeingIdleStatusRequest: null,
  clearSpottedVehicleRequest: null,
  clearSubmitInfractionAnswerRequest: null,

  // Clear all caches
  clearShiftRequest: null,
});

export const ShiftTypes = Types;
export default Creators;
